export default "__VITE_ASSET__Mo0_KURm__"